export class TokenUserDataError extends Error {
    constructor(...params: any[]) {
        super(...params);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TokenUserDataError);
        }

        this.name = 'TokenUserDataError';
    }

    static fromUserAttribute(userAttribute: string): TokenUserDataError {
        return new TokenUserDataError(`User attribute not found in JWT token: ${userAttribute}`);
    }
}

export default TokenUserDataError;
